import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';

import { PaymentReceiptsComponent } from './payment-receipts.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'payment-receipts',
          component: PaymentReceiptsComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {roles: ['Operator', 'Customer', 'User']},
          children: [
            // {
            //   path: 'create/:key',
            //   component: CreateInvoiceDialogComponent,
            //   data: {roles: ['Customer']},
            // },
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class PaymentReceiptsModule { }
